import React, { Fragment } from 'react';
import SiteHeader from '../../../components/SiteHeader';
import { useParams, Link } from 'react-router-dom';
import Breadcumb from '../../../components/Breadcumb';
import CallToAction from '../../../components/CallToAction';
import FaqSection from '../../../components/FaqSection';
import FooterArea from '../../../components/FooterArea';
import Seo from '../../../components/Seo';
import { serviceSchema, faqSchema, breadcrumbSchema } from '../../../seo/config';
import { PRACTICE_AREAS, getPracticeArea } from '../../../data/practiceAreas';
import breadcumb from '../../../images/breadcumb/about-practice.jpg';
import './style.scss';

const PracticeArea = () => {
    const { slug } = useParams();
    const area = getPracticeArea(slug);

    if (!area) {
        return (
            <Fragment>
                <Seo title="Practice Area Not Found" path={`/practice/${slug}`} noindex />
                <SiteHeader />
                <main className="practiceAreaMissing">
                    <h1>Practice area not found</h1>
                    <p>The page you’re looking for doesn’t exist. <Link to="/practice">View all practice areas</Link>.</p>
                </main>
                <FooterArea />
            </Fragment>
        );
    }

    const path = `/practice/${area.slug}`;
    const related = PRACTICE_AREAS.filter((p) => p.slug !== area.slug).slice(0, 3);

    return (
        <Fragment>
            <Seo
                title={area.metaTitle}
                description={area.metaDescription}
                path={path}
                schema={[
                    serviceSchema({ name: area.name, description: area.metaDescription, path, serviceType: area.name }),
                    faqSchema(area.faqs),
                    breadcrumbSchema([
                        { name: 'Home', path: '/' },
                        { name: 'Practice Areas', path: '/practice' },
                        { name: area.name, path },
                    ]),
                ]}
            />
            <SiteHeader />
            <main>
                <Breadcumb
                    className="breadcumbArea"
                    title={area.h1}
                    breadcumbMenu={[
                        { name: 'Home', route: '/' },
                        { name: 'Practice Areas', route: '/practice' },
                        { name: area.name },
                    ]}
                    background={breadcumb}
                />

                <section className="practiceAreaIntro">
                    <div className="container">
                        <div className="paColumns">
                            <div className="paMain">
                                {area.intro.map((p, i) => (
                                    <p key={i}>{p}</p>
                                ))}

                                <h2>How we can help</h2>
                                <ul className="paServices">
                                    {area.services.map((s, i) => (
                                        <li key={i}>{s}</li>
                                    ))}
                                </ul>

                                <div className="paCta">
                                    <p>Facing a {area.name.toLowerCase()} matter? Speak to our advocates in confidence.</p>
                                    <Link to="/contact" className="paBtn">Book a Consultation</Link>
                                </div>
                            </div>

                            <aside className="paSidebar">
                                <div className="paCard">
                                    <h3>Practice Areas</h3>
                                    <ul>
                                        {PRACTICE_AREAS.map((p) => (
                                            <li key={p.slug} className={p.slug === area.slug ? 'active' : ''}>
                                                <Link to={`/practice/${p.slug}`}>{p.name}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="paCard paContact">
                                    <h3>Need legal help?</h3>
                                    <p>Call us for a confidential discussion.</p>
                                    <a href="tel:+919555690946" className="paPhone">+91 95556 90946</a>
                                    <Link to="/contact" className="paBtn">Contact Us</Link>
                                </div>
                            </aside>
                        </div>
                    </div>
                </section>

                <FaqSection
                    title={`${area.name} — FAQs`}
                    subTitle="Your Questions, Answered"
                    faqs={area.faqs}
                />

                <section className="paRelated">
                    <div className="container">
                        <h2>Related Practice Areas</h2>
                        <div className="paRelatedGrid">
                            {related.map((p) => (
                                <Link key={p.slug} to={`/practice/${p.slug}`} className="paRelatedCard">
                                    <h3>{p.name}</h3>
                                    <span>Learn more →</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>

                <CallToAction />
            </main>
            <FooterArea />
        </Fragment>
    );
};

export default PracticeArea;
